<div class="multi-form-version-selector">
  <ng-container *ngIf="hasForms; else selectFormInfo">
    <div *ngFor="let block of blocks; trackBy: trackByFormId" class="form-version-block">
      <hr *ngIf="block.showDivider" class="form-version-divider" />

      <div *ngIf="block.showFormName" class="form-version-form-name small fw-bold text-muted text-truncate">
        {{ block.formName }}
      </div>

      <div class="form-version-block-body d-flex flex-column gap-2">
        <div *ngIf="block.loading" class="form-version-loading-mask">
          <i class="fas fa-spin fa-spinner"></i>
        </div>

        <div class="form-check form-version-latest">
          <input
            type="checkbox"
            class="form-check-input"
            [id]="block.checkboxId"
            [ngModel]="block.useAlwaysLatest"
            [disabled]="block.checkboxDisabled"
            (ngModelChange)="onUseAlwaysLatestChange(block.formId, $event)"
            (blur)="onTouched()" />
          <label class="form-check-label" [for]="block.checkboxId">
            {{ 'Dashboard::QualityReport:UseLatestVersion' | abpLocalization }}
            <span *ngIf="block.latestVersionNumber !== null">
              (v{{ block.latestVersionNumber }})
            </span>
          </label>
        </div>

        <div *ngIf="!block.useAlwaysLatest" class="row m-0 align-items-center">
          <div class="col p-0">
            <ng-select
              #versionSelect
              [items]="block.versions"
              [ngModel]="block.selectedVersion"
              [compareWith]="compareVersions"
              [disabled]="block.dropdownDisabled"
              [clearable]="false"
              [searchable]="false"
              dropdownPanelClass="fill-width form-version-selector-dropdown"
              bindLabel="version"
              (open)="onDropdownOpen(versionSelect)"
              (change)="onVersionChange(block.formId, $event)"
              (blur)="onTouched()">
              <ng-template ng-label-tmp let-item="item">
                {{ item.version }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{ item.version }}
              </ng-template>
            </ng-select>
          </div>
          <div class="col-auto ps-2">
            <button
              class="ca-btn ca-btn-link ca-btn-link-sm p-0"
              type="button"
              [disabled]="isDisabled"
              (click)="onClearSelectionClick(block.formId, $event)">
              {{ '::Clear' | abpLocalization }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #selectFormInfo>
    <div class="form-version-info d-flex align-items-center gap-2 text-muted">
      <i class="fa-regular fa-circle-info"></i>
      <span>{{ 'Dashboard::QualityReport:FormVersion.SelectFormFirst' | abpLocalization }}</span>
    </div>
  </ng-template>
</div>
